import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './SandboxMark.css';

/** True on the Arcos Sandbox's deployments (sandbox.arcos.network), which hold test data only. */
export const IS_SANDBOX = import.meta.env.VITE_ARCOS_ENV === 'sandbox';
const TITLE_PREFIX = 'Sandbox · ';

/**
 * The Arcos Sandbox says so on every screen: a fixed mark in the corner and "Sandbox ·" before every
 * tab's title, so nobody takes its test data for production's or works there thinking it is. The
 * Sandbox is a second deployment over a second database (VITE_ARCOS_ENV=sandbox on its branch only);
 * everywhere else this renders nothing and touches nothing. The mark ignores the pointer, so it never
 * covers a control.
 */
export default function SandboxMark() {
  useEffect(() => {
    if (!IS_SANDBOX) return undefined;
    document.documentElement.dataset.arcosEnv = 'sandbox';
    // Pages set their own titles as they go, so the prefix is put back whenever the title changes.
    const mark = () => { if (!document.title.startsWith(TITLE_PREFIX)) document.title = `${TITLE_PREFIX}${document.title}`; };
    mark();
    const observer = new MutationObserver(mark);
    observer.observe(document.head, { subtree: true, childList: true, characterData: true });
    return () => observer.disconnect();
  }, []);
  if (!IS_SANDBOX) return null;
  return createPortal(
    <div className="arcos-sandbox-mark" role="note" aria-label="Arcos Sandbox: test data, not production">
      <strong>Arcos Sandbox</strong>
      <span>test data</span>
    </div>,
    document.body,
  );
}
